// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'

export interface GetSocialAppIds {

}

export interface SocialAppIds {
  Google: string
  GoogleApp: string
}

/**
 * Validate GetSocialAppIds request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param _request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateGetSocialAppIds(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateGetSocialAppIds(_request: GetSocialAppIds): ValidationError[] {
  const errors: ValidationError[] = []



  return errors
}

export const getSocialAppIds = postEndpoint<GetSocialAppIds, SocialAppIds>('/auth/getSocialAppIds')
